import {
  EditOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Empty,
  Modal,
  Pagination,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import React, { useCallback, useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "../../../../../contexts/UserContext";
import { useWidth } from "../../../../../hooks";
import { OPCOES_TAMANHO_PAGINA, USER_ROLES } from "../../../../../utils";
import { denunciaService } from "../../../../../services/resources/denunciaService";
import { openNotification } from "../../../../../components/Notification";
import { PessoaModal } from "../PessoaModal";
import { PessoaPaginada } from "../../../../Pessoas/components/PessoaPaginada/index";

export function Envolvidos({
  handleNext,
  enable = false,
  tipo,
  showActions = true,
  next,
  prev,
}) {
  const { user } = useContext(UserContext);

  const { codigo: codigoDenuncia } = useParams();
  const { width } = useWidth();

  const [searchModal, setSearchModal] = useState(false);
  const [novo, setNovo] = useState(null);
  const [envolvidos, setEnvolvidos] = useState([]);
  const [person, setPerson] = useState(null);
  const [modeModal, setModeModal] = useState(null);
  const [loading, setloading] = useState(false);
  const [pessoalModalOpen, setPessoalModalOpen] = useState(false);
  const [searchModalWasOpen, setSearchModalWasOpen] = useState(false);
  const [pessoaCriada, setPessoaCriada] = useState(false);

  const [paginacao, setPaginacao] = useState({
    currentPage: 0,
    totalElements: 0,
    size: OPCOES_TAMANHO_PAGINA[0],
  });

  useEffect(() => {
    if (codigoDenuncia) {
      getEnvolvidos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoDenuncia]);

  useEffect(() => {
    async function inserir() {
      if (!novo) return;
      const pessoaParaInserir = novo;
      setNovo(null); // Limpa o estado imediatamente para evitar re-execução
      try {
        setloading(true);
        await denunciaService[tipo].inserir(
          codigoDenuncia,
          pessoaParaInserir?.codigo
        );

        openNotification(
          "success",
          <strong>Pessoa inserida com sucesso!</strong>,
          "A pessoa foi vinculada a este atendimento."
        );
        getEnvolvidos();
      } catch (error) {
        openNotification(
          "error",
          <strong>Ocorreu um erro ao inserir a pessoa no atendimento!</strong>,
          error.response?.data?.userMessage
        );
      } finally {
        setloading(false);
      }
    }

    inserir();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [novo]);

  async function getEnvolvidos() {
    try {
      setloading(true);
      const response = await denunciaService[tipo].listar(codigoDenuncia);
      setEnvolvidos(response?.data);
      setPaginacao({
        currentPage: response?.data?.currentPage,
        totalElements: response?.data?.totalElements,
        size: response?.data?.size,
      });
    } catch (error) {
      openNotification(
        "error",
        <strong>Ocorreu um erro ao buscar as pessoas da denúncia!</strong>,
        error?.response?.data?.userMessage
      );
    } finally {
      setloading(false);
    }
  }

  async function remover(codigo) {
    try {
      setloading(true);

      await denunciaService[tipo].remover(codigoDenuncia, codigo);

      openNotification(
        "success",
        <strong>Pessoa removida com sucesso!</strong>,
        "Essa pessoa foi desvinculada do atendimento."
      );

      getEnvolvidos();
    } catch (error) {
      openNotification(
        "error",
        <strong>Ocorreu um erro ao remover a pessa do atendimento!</strong>,
        error.response.data.userMessage
      );
    } finally {
      setloading(false);
    }
  }

  const columns = [
    { title: <strong>Nome</strong>, dataIndex: "nome", key: "nome" },
    { title: <strong>CPF</strong>, dataIndex: "cpf", key: "cpf" },
    {
      title: <strong>Endereço</strong>,
      dataIndex: ["endereco", "logradouro"],
      key: "endereco.logradouro",
    },
    {
      title: <strong>Bairro</strong>,
      dataIndex: ["endereco", "bairro", "nome"],
      key: "endereco.bairro.nome",
    },
    {
      title: <strong>Cidade</strong>,
      dataIndex: ["endereco", "bairro", "cidade", "nome"],
      key: "endereco.bairro.cidade.nome",
    },
  ];

  const colunasAcoes = {
    title: <strong>Ações</strong>,
    key: "action",
    fixed: "right",
    width: 32,
    render: ({ nome, codigo }) => (
      <Space size="small">
        <Button
          type="primary"
          className="action-button"
          ghost
          title={`Visualizar ${nome}`}
          onClick={() => handleOpenCrudModal("view", codigo)}
        >
          <EyeOutlined style={{ fontSize: "1.2rem" }} />
        </Button>
        {enable && (
          <>
            <Button
              type="primary"
              className="action-button"
              title={`Editar ${nome}`}
              onClick={() => handleOpenCrudModal("edit", codigo)}
            >
              <EditOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <Button
              onClick={() => remover(codigo)}
              title={`Remover ${nome} deste atendimento`}
              type="danger"
            >
              Remover do atendimento
            </Button>
          </>
        )}
      </Space>
    ),
  };

  const colunaAcoesPessoas = ({ nome, codigo }) => (
    <Space size="small">
      {envolvidos.find((pessoa) => pessoa.codigo === codigo) ? (
        <Button
          key="remove"
          type="danger"
          title={`Remover ${nome} desta denúncia`}
          onClick={() => {
            remover(codigo);
            setSearchModal(false);
          }}
        >
          Remover da denúncia
        </Button>
      ) : (
        <Button
          onClick={() => {
            setNovo({ nome, codigo });
            setSearchModal(false);
          }}
          title={`Inserir ${nome} neste atendimento`}
          type="primary"
        >
          Inserir no atendimento
        </Button>
      )}
      <Button
        type="primary"
        ghost
        className="action-button"
        title={`Visualizar ${nome}`}
        onClick={() => handleOpenCrudModal("view", codigo)}
      >
        <EyeOutlined style={{ fontSize: "1.2rem" }} />
      </Button>
      <Button
        type="primary"
        className="action-button"
        title={`Editar ${nome}`}
        onClick={() => handleOpenCrudModal("edit", codigo)}
      >
        <EditOutlined style={{ fontSize: "1.2rem" }} />
      </Button>
    </Space>
  );

  const handleOpenCrudModal = useCallback(
    (mode, personId) => {
      setPerson(personId);
      setModeModal(mode);
      // Se o modal de escolher pessoa estiver aberto, guarda essa informação
      if (searchModal) {
        setSearchModalWasOpen(true);
      }
      setPessoalModalOpen(true);
    },
    [searchModal]
  );

  const handleCloseCrudModal = useCallback(() => {
    setPessoalModalOpen(false);
    // Se o modal de escolher pessoa estava aberto antes, reabre ele
    // Mas não reabre se uma pessoa foi criada recentemente
    if (searchModalWasOpen && !pessoaCriada) {
      setSearchModal(true);
      setSearchModalWasOpen(false);
    }
    // Reseta a flag após fechar o modal
    if (pessoaCriada) {
      setPessoaCriada(false);
      setSearchModalWasOpen(false);
    }
  }, [searchModalWasOpen, pessoaCriada]);

  return (
    <Col span={24}>
      <Row justify="end" align="middle">
        {enable &&
          (user?.authorities?.includes(USER_ROLES.CONSULTAR_PESSOAS) ||
            user?.authorities?.includes(USER_ROLES.GERENCIAR_PESSOA)) && (
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => setSearchModal(true)}
            >
              {width >= 720 && "Buscar Pessoa"}
            </Button>
          )}
      </Row>

      <Row gutter={[16, 16]} justify="center" style={{ marginTop: "1rem" }}>
        {envolvidos.length > 0 ? (
          <Col span={24}>
            <Table
              loading={loading}
              dataSource={envolvidos}
              columns={[...columns, colunasAcoes]}
              size="small"
              rowKey="codigo"
              pagination={false}
            />
            <Row justify="end" style={{ marginTop: "1rem" }}>
              <Pagination
                size="small"
                showSizeChanger
                simple={width < 768}
                pageSizeOptions={OPCOES_TAMANHO_PAGINA}
                total={envolvidos.length}
                showTotal={(total) => (
                  <strong>
                    {total === 1
                      ? `${total} pessoa no total`
                      : `${total} pessoas no total`}
                  </strong>
                )}
                current={paginacao.currentPage + 1}
              />
            </Row>
          </Col>
        ) : (
          <Row justify="center">
            <Empty description={<h2>Sem pessoas neste atendimento</h2>} />
          </Row>
        )}
      </Row>

      {showActions && (
        <Row
          style={{ marginTop: 20 }}
          gutter={[16, 16]}
          justify="space-between"
          align="bottom"
        >
          <Tooltip title="Todas as alterações nesta página já estão salvas!">
            <Button onClick={() => handleNext(prev)}>Anterior</Button>
          </Tooltip>
          <Tooltip title="Todas as alterações nesta página já estão salvas!">
            <Button onClick={() => handleNext(next)}>Próximo</Button>
          </Tooltip>
        </Row>
      )}

      <PessoaModal
        onClose={handleCloseCrudModal}
        mode={modeModal}
        visible={pessoalModalOpen}
        codigo={person}
        codigoDenuncia={codigoDenuncia}
        afterCreate={(novaPessoa) => {
          setNovo(novaPessoa);
          setPessoaCriada(true);
          // Fecha o modal de busca se estiver aberto
          if (searchModal) {
            setSearchModal(false);
          }
          setSearchModalWasOpen(false);
        }}
        refresh={getEnvolvidos}
      />

      <Modal
        title={
          <Row justify="space-between" align="middle">
            <strong>Escolha uma pessoa</strong>
            <Button
              type="primary"
              onClick={() => {
                handleOpenCrudModal("create");
              }}
            >
              Cadastrar Pessoa
            </Button>
          </Row>
        }
        width="90vw"
        bodyStyle={{
          height: "70vh",
          overflowY: "auto",
        }}
        closable={false}
        centered
        visible={searchModal}
        destroyOnClose
        onCancel={() => {
          setSearchModal(false);
          setSearchModalWasOpen(false);
        }}
        zIndex={1000}
        footer={
          <Button
            key="back"
            type="danger"
            onClick={() => {
              setSearchModal(false);
              setSearchModalWasOpen(false);
            }}
          >
            Cancelar
          </Button>
        }
      >
        <PessoaPaginada
          tableActions={colunaAcoesPessoas}
          cardActions={({ nome, codigo }) => [
            envolvidos.find((pessoa) => pessoa.codigo === codigo) ? (
              <Button
                key="remove"
                type="danger"
                icon={<MinusCircleOutlined />}
                title={`Remover ${nome} do atendimento`}
                onClick={() => {
                  remover(codigo);
                  setSearchModal(false);
                }}
              />
            ) : (
              <Button
                key="add"
                type="primary"
                icon={<PlusCircleOutlined />}
                title={`Inserir ${nome} no atendimento `}
                onClick={() => {
                  setNovo({ nome, codigo });
                  setSearchModal(false);
                }}
              />
            ),
            <Button
              key="view"
              type="primary"
              ghost
              title={`Visualizar ${nome}`}
              onClick={() => handleOpenCrudModal("view", codigo)}
              icon={<EyeOutlined />}
            />,
            <Button
              key="edit"
              type="primary"
              title={`Editar ${nome}`}
              onClick={() => handleOpenCrudModal("edit", codigo)}
              icon={<EditOutlined />}
            />,
          ]}
        />
      </Modal>
    </Col>
  );
}
